// === Data Loading (JSON + JS Fallback) ===

import store from '../state/store.js';
import { getElements } from '../utils/dom.js';

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = url;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error('Script load failed'));
    document.head.appendChild(s);
  });
}

export async function loadAdvisories() {
  const els = getElements();

  try {
    const res = await fetch('/data/data.json');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    store.seed = await res.json();
  } catch (err) {
    console.warn('Fetch data.json failed, attempting JS fallback', err);
    try {
      if (!window.ADVISEED) {
        await loadScript('/data/data.js');
      }
      store.seed = window.ADVISEED || [];
    } catch (fallbackErr) {
      console.error('Failed to load advisory data', fallbackErr);
      store.seed = [];
      els.emptyMsg.style.display = 'block';
      els.normalGrid.style.display = 'none';
      document.getElementById('normalTitle').style.display = 'none';
      els.emptyMsg.querySelector('p').textContent =
        'Unable to load advisory data. Open via local server or ensure data/data.json is reachable.';
      return false;
    }
  }
  return true;
}
